import { render, staticRenderFns } from "./PNR_Pending.vue?vue&type=template&id=9d5c8776&scoped=true&"
import script from "./PNR_Pending.vue?vue&type=script&lang=js&"
export * from "./PNR_Pending.vue?vue&type=script&lang=js&"
import style0 from "./PNR_Pending.vue?vue&type=style&index=0&id=9d5c8776&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5c8776",
  null
  
)

export default component.exports